import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import store from "./ducks/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import checkForUpdate from "./versioning";

ReactDOM.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>,
  document.getElementById("root") as HTMLElement
);

registerServiceWorker();
setInterval(checkForUpdate, 60000);
